import React from "react";
import {
  Navigate,
  Route,
  Routes,
  BrowserRouter as Router,
} from "react-router-dom";
import Home from "../../pages/Home";
import CreateAnnonce from "../../pages/CreateAnnonce";
import Profil from "../../pages/Profil";
import AnnoncesParCategorie from "../../pages/AnnonceParCategorie";
import Annonces from "../../pages/Annonces";
import AdminRoute from "./AdminRoute";
import AdminPage from "../../pages/AdminPage";
import ResetPasswordForm from "../Password/ResetPasswordForm";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const index = () => {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={5000} />
      <Routes>
        <Route path="/" exact Component={Home}></Route>
        <Route path="/Annonces" exact Component={Annonces}></Route>
        <Route path="/annoncesparcategorie" element={<AnnoncesParCategorie />} />
        <Route path="/CreationAnnonce" exact Component={CreateAnnonce}></Route>
        <Route path="/Profil" exact Component={Profil}></Route>
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminPage />
            </AdminRoute>
          }
        />
        <Route
          path="/reset-password/:token"
          exact
          Component={ResetPasswordForm}
        />
        <Route path="*" exact Component={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default index;
